enum BordereauEtatAcquittement {
  ACQUITTE = 1,
  NON_ACQUITTE = 0,
}

export default BordereauEtatAcquittement;
